import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar/Sidebar';
import Navbar from '../components/Navbar/Navbar';

function MainLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
        setIsSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="main-layout">
      <div
        className={`fixed top-12 left-0 h-screen w-64 bg-white z-50 transform transition-transform duration-300 
          ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
          ${isMobile ? '' : 'sm:translate-x-0'}`}
      >
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      </div>
      <div className={`content flex-1 transition-all duration-300 ${!isMobile ? 'sm:ml-64' : ''}`}>
        <div className="navbar fixed top-0 left-0 right-0 h-16 z-40">
          <Navbar toggleSidebar={toggleSidebar} />
        </div>
        <main className="mt-16 p-10 xs:p-6 flex">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default MainLayout;
